<template>
  <div class="rentalObjectTenancies">
    <h2 class="mb-5">{{ defaultHeader }}</h2>

    <RentalObjectTenancies :rentalObjectId="rentalObjectId" />
  </div>
</template>

<script>
import RentalObjectTenancies from '@/components/detailedRentalObject/RentalObjectTenancies.vue';

export default {
  props: {
    rentalObjectId: [Number, String],
    defaultHeader: String,
  },

  components: {
    RentalObjectTenancies,
  },
};
</script>
